
export const SEND_RESET_CODE_REQUEST = "send_reset_code_request"
export const SEND_RESET_CODE_SUCCESS = "send_reset_code_success"
export const SEND_RESET_CODE_FAILURE = "send_reset_code_failure"

export const VERIFY_RESET_CODE_REQUEST = "verify_reset_code_request"
export const VERIFY_RESET_CODE_SUCCESS = "verify_reset_code_success"
export const VERIFY_RESET_CODE_FAILURE = "verify_reset_code_failure"

export const RESET_USER = "reset_user"
export const RESET_USER_SUCCESSFUL = "reset_user_successfull"
export const RESET_USER_FAILED = "reset_user_failed"

export const CLEAR_SUCCESS = "CLEAR_SUCCESS"
export const RESET_STEP = "RESET_STEP"
